import { LOCAL_FILTERS_STORAGE_MAP } from '@/context/LocalFiltersRegistry/localFiltersKeys';
import { isRecord } from '@/utils/filter/isRecord';

/**
 * Reads local filters from all pages via sessionStorage.
 * Unlike `getAllLocalFilters()` from the registry (which only returns
 * filters from currently mounted components), this reads persisted
 * filters from every page that has ever stored them.
 */
const collectAllLocalFilters = (): Record<string, Record<string, unknown>> => {
  const result: Record<string, Record<string, unknown>> = {};

  for (const [registryKey, storageKey] of Object.entries(LOCAL_FILTERS_STORAGE_MAP)) {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (!raw) continue;
      const parsed: unknown = JSON.parse(raw);
      if (!isRecord(parsed)) continue;

      const hasValues = Object.values(parsed).some(filterEntry => {
        if (Array.isArray(filterEntry) && filterEntry.length > 0) return true;
        if (isRecord(filterEntry)) {
          return Object.values(filterEntry).some(nestedValue => Array.isArray(nestedValue) && nestedValue.length > 0);
        }
        return false;
      });

      if (hasValues) {
        result[registryKey] = parsed;
      }
    } catch {
      // skip malformed entries
    }
  }

  return result;
};

export default collectAllLocalFilters;
